/**
 * class dependency:
 * - TextShape
 * - Tools/MovePathTool
 */

function ArcShape(draw, text, options) {
    TextShape.call(this, draw, text);

    var _this = this;
    var bbox = this.text.bbox();

    var adjustment = (bbox.width * 0.25);

    options = Object.assign({
        pointRadius: 10,
        pointColor: "rgba(0, 0, 0, 0.3)",

        point1: {
            color: "blue",
            position: {
                x: bbox.x - adjustment,
                y: bbox.y,
            }
        },
        point2: {
            color: "red",
            position: {
                x: bbox.x + adjustment,
                y: bbox.y - (bbox.width/2) + adjustment,
            }
        },
        point3: {
            color: "green",
            position: {
                x: (bbox.x + bbox.width) - adjustment,
                y: (bbox.y - (bbox.width/2)) + adjustment,
            }
        },
        point4: {
            color: "orange",
            position: {
                x: bbox.x + bbox.width + adjustment,
                y: bbox.y,
            }
        },
    }, options);

    var textLine = function() {
        var textLinePath = "M " + bbox.x + " " + (bbox.y + bbox.height);
        textLinePath += " h " + bbox.width;

        _this.textLine = _this.draw.path(textLinePath);
        _this.textLine.fill("none");
        _this.textLine.stroke({
            color: "#000",
            width: 2
        });

        var textPath = "M " + bbox.x + " " + bbox.y;
        textPath += " h " + bbox.width;
        _this.text.path(textPath);
        _this.text.textPath().attr({
            'text-anchor': "middle",
            startOffset: "50%"
        });

        // fix moving when calling "path" method
        var newBbox = _this.text.bbox();
        textPath = "M " + (bbox.x - newBbox.x) + " " + (bbox.y - newBbox.y);
        textPath += " h " + bbox.width;
        _this.text.plot(textPath);
    };

    // starting point
    var point1 = function() {
        _this.point1 = _this.draw.circle();
        _this.point1.radius(options.pointRadius);
        _this.point1.fill(options.point1.color || options.pointColor);
        _this.point1.move(options.point1.position.x, options.point1.position.y);
    };

    var point2 = function() {
        _this.point2 = _this.draw.circle(); // bezier point 1

        _this.point2.radius(options.pointRadius);
        _this.point2.fill(options.point2.color || options.pointColor);
        _this.point2.move(options.point2.position.x, options.point2.position.y);
    };

    var line1 = function() {
        _this.line1 = _this.draw.line(
            options.point1.position.x, options.point1.position.y,
            options.point2.position.x, options.point2.position.y
        ); // line for starting and bezier point1

        _this.line1.stroke({
            width: 1,
            fill: "#000"
        });
    };

    var point3 = function() {
        _this.point3 = _this.draw.circle(); // bezier point 2

        _this.point3.radius(options.pointRadius);
        _this.point3.fill(options.point3.color || options.pointColor);
        _this.point3.move(options.point3.position.x, options.point3.position.y);
    };

    var point4 = function() {
        _this.point4 = _this.draw.circle(); // final point

        _this.point4.radius(options.pointRadius);
        _this.point4.fill(options.point4.color || options.pointColor);
        _this.point4.move(options.point4.position.x, options.point4.position.y);
    };

    var line2 = function() {
        _this.line2 = _this.draw.line(
            options.point3.position.x, options.point3.position.y,
            options.point4.position.x, options.point4.position.y
        ); // line for bezier point2 and final point

        _this.line2.stroke({
            width: 1,
            fill: "#000"
        });
    };

    var combine = function() {
        _this.group = _this.draw.group();

        _this.group.add(_this.line1);
        _this.group.add(_this.point1);
        _this.group.add(_this.point2);

        _this.group.add(_this.line2);
        _this.group.add(_this.point3);
        _this.group.add(_this.point4);
    };

    var activateEvent = function() {
        var updatePosition = function() {
            var point1Bbox = _this.point1.bbox();
            var point2Bbox = _this.point2.bbox();
            var point3Bbox = _this.point3.bbox();
            var point4Bbox = _this.point4.bbox();

            var d = "M " + point1Bbox.x + " " + point1Bbox.y;
                d += " C " + point2Bbox.x + " " + point2Bbox.y;
                d += " " + point3Bbox.x + " " + point3Bbox.y;
                d += " " + point4Bbox.x + " " + point4Bbox.y;

            _this.text.plot(d);
            _this.textLine.plot(d);
        };

        new MovePathTool(_this.draw, _this.line1, _this.point1, _this.point2, function() {
            updatePosition();
        });

        new MovePathTool(_this.draw, _this.line2, _this.point3, _this.point4, function() {
            updatePosition();
        });

        updatePosition();
    };

    textLine();
    point1();
    point2();
    point3();
    point4();
    line1();
    line2();
    combine();
    activateEvent();
}

// extends
ArcShape.prototype = Object.create(TextShape.prototype);
ArcShape.prototype.constructor = ArcShape;

Object.assign(ArcShape.prototype, {
    getTextBbox: function() {
        var currentText = this.text;
        var currentTextBbox = this.text.bbox();

        // create temporary text to determine the text length
        var tempText = this.draw.text(currentText.text());
        tempText.font("fill", "transparent");

        var font_family = this.text.attr("font-family");
        var font_size = this.text.attr("font-size");

        if (font_family !== null) {
            tempText.font("family", font_family);
        }
        if (font_size !== null) {
            tempText.font("size", font_size);
        }

        var bbox = tempText.bbox();

        tempText.remove(); // delete temporary text

        return bbox;
    },

    updatePosition: function() {
        var bbox = this.getTextBbox();

        var adjustment = (bbox.width * 0.25);

        var positions = {
            point1: {
                x: bbox.x - adjustment,
                y: bbox.y
            },
            point2: {
                x: bbox.x + adjustment,
                y: bbox.y - (bbox.width/2) + adjustment
            },
            point3: {
                x: (bbox.x + bbox.width) - adjustment,
                y: (bbox.y - (bbox.width/2)) + adjustment
            },
            point4: {
                x: bbox.x + bbox.width + adjustment,
                y: bbox.y
            }
        };

        // number of text adjustment
        positions.point1.x -= 25;
        positions.point4.x += 25;
        this.text.attr('letter-spacing', 10);
        switch (this.text.text().length) {
            case 2:
                this.text.attr('letter-spacing', 65);

                break;

            case 3:
                this.text.attr('letter-spacing', 40);

                break;

            case 4:
            case 5:
                this.text.attr('letter-spacing', 30);

                break;

            case 6:
            case 7:
                this.text.attr('letter-spacing', 20);

                break;

            case 8:
                this.text.attr('letter-spacing', 15);

                break;
        }

        var topLeftAdjustment = {
            x: (positions.point1.x * -1),
            y: (positions.point2.y * -1)
        };

        positions.point1.x += topLeftAdjustment.x;
        positions.point1.y += topLeftAdjustment.y;
        positions.point2.x += topLeftAdjustment.x;
        positions.point2.y += topLeftAdjustment.y;
        positions.point3.x += topLeftAdjustment.x;
        positions.point3.y += topLeftAdjustment.y;
        positions.point4.x += topLeftAdjustment.x;
        positions.point4.y += topLeftAdjustment.y;

        this.point1.move(positions.point1.x, positions.point1.y);
        this.point2.move(positions.point2.x, positions.point2.y);
        this.point3.move(positions.point3.x, positions.point3.y);
        this.point4.move(positions.point4.x, positions.point4.y);

        var d = "M " + positions.point1.x + " " + positions.point1.y;
            d += " C " + positions.point2.x + " " + positions.point2.y;
            d += " " + positions.point3.x + " " + positions.point3.y;
            d += " " + positions.point4.x + " " + positions.point4.y;

        this.text.plot(d);
        this.textLine.plot(d);
        this.line1.plot([[positions.point1.x, positions.point1.y], [positions.point2.x, positions.point2.y]]);
        this.line2.plot([[positions.point3.x, positions.point3.y], [positions.point4.x, positions.point4.y]]);
    },

    moveToCenter: function(xAdjustment, yAdjustment) {
        xAdjustment = xAdjustment || 0;
        yAdjustment = yAdjustment || 0;

        var width = parseInt(this.draw.attr('width'));
        var height = parseInt(this.draw.attr('height'));

        var groupBbox = this.group.bbox();
        // this.group.move((width/2)-(groupBbox.width/2), (height/2)-(groupBbox.height/2))

        var point1 = this.point1.bbox();
        var point2 = this.point2.bbox();
        var point3 = this.point3.bbox();
        var point4 = this.point4.bbox();

        point1.x += (((width/2) - (groupBbox.width/2)) + xAdjustment);
        point1.y += (((height/2) - (groupBbox.height/2)) + yAdjustment);
        point2.x += (((width/2) - (groupBbox.width/2)) + xAdjustment);
        point2.y += (((height/2) - (groupBbox.height/2)) + yAdjustment);
        point3.x += (((width/2) - (groupBbox.width/2)) + xAdjustment);
        point3.y += (((height/2) - (groupBbox.height/2)) + yAdjustment);
        point4.x += (((width/2) - (groupBbox.width/2)) + xAdjustment);
        point4.y += (((height/2) - (groupBbox.height/2)) + yAdjustment);

        this.point1.move(point1.x, point1.y);
        this.point2.move(point2.x, point2.y);
        this.point3.move(point3.x, point3.y);
        this.point4.move(point4.x, point4.y);

        var d = "M " + point1.x + " " + point1.y;
            d += " C " + point2.x + " " + point2.y;
            d += " " + point3.x + " " + point3.y;
            d += " " + point4.x + " " + point4.y;


        var textPathAdjusment = "M " + point1.x + " " + (point1.y - (groupBbox.height/2));
            textPathAdjusment += " C " + point2.x + " " + (point2.y - (groupBbox.height/2));
            textPathAdjusment += " " + point3.x + " " + (point3.y - (groupBbox.height/2));
            textPathAdjusment += " " + point4.x + " " + (point4.y - (groupBbox.height/2));

        this.text.plot(textPathAdjusment);
        this.textLine.plot(d);
        this.line1.plot([[point1.x, point1.y], [point2.x, point2.y]]);
        this.line2.plot([[point3.x, point3.y], [point4.x, point4.y]]);
    },

    removeTool: function() {
        this.textLine.remove();
        this.point1.remove();
        this.point2.remove();
        this.point3.remove();
        this.point4.remove();
        this.line1.remove();
        this.line2.remove();
        this.group.remove();
    },

    hideTool: function() {
        this.textLine.style("visibility", "hidden");
        this.point1.style("visibility", "hidden");
        this.point2.style("visibility", "hidden");
        this.point3.style("visibility", "hidden");
        this.point4.style("visibility", "hidden");
        this.line1.style("visibility", "hidden");
        this.line2.style("visibility", "hidden");
        this.group.style("visibility", "hidden");
    },

    // overload methods
    returnToOriginalText: function() {
        var defsId = this.text.node.querySelector("textPath").getAttribute("href");

        this.removeTool(); // remove arc tools
        this.text.remove(); // remove text
        this.draw.node.querySelector(defsId).remove(); // remove definition

        this.showOriginaText();
    },
});